import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";

import HexagonContainer from "containers/Next/Hexagon";

import DoubleOutcomeChart from "components/Next/Charts/DoubleOutcomeChart";

import { CHART_TYPES } from "containers/Report/ReportReducer";
import { colors } from "containers/Next/NextReducer";

import styles from "./style.module.css";

const HEXAGON_COLOR = "#F2F3F7";
const SELECTED_COLOR = "white";

export default class Minimap extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mViewStyle: {}
    };
  }

  componentDidMount() {
    const mainScroll = document.getElementById("mainScroll");

    mainScroll.addEventListener("scroll", this.handleMainScroll.bind(this), false);

    mainScroll &&
      mainScroll.scrollTo({
        top: (mainScroll.scrollHeight - mainScroll.offsetHeight + 160) / 2,
        left: (mainScroll.scrollWidth - mainScroll.offsetWidth - 560) / 2
      });
  }

  componentDidUpdate(prevProps) {
    const { nextZoomSize, hexSize } = this.props;

    const mainScroll = document.getElementById("mainScroll");

    if (hexSize !== prevProps.hexSize) {
      const { mViewStyle } = this.state;

      const sLeft = mViewStyle?.left;
      const sTop = mViewStyle?.top;

      const leftRatio = sLeft / 240;
      const topRatio = sTop / 180;

      if (this.updateAnimation !== undefined) {
        clearInterval(this.updateAnimation);
      }

      this.updateAnimation = setTimeout(() => {
        mainScroll.scrollLeft = leftRatio * mainScroll.scrollWidth;
        mainScroll.scrollTop = topRatio * mainScroll.scrollHeight;
      }, 200);
    }

    if (prevProps.nextZoomSize !== nextZoomSize) {
      const ratio = nextZoomSize / hexSize;

      const screenHeight = mainScroll.offsetHeight / mainScroll.scrollHeight / ratio;
      const screenWidth = mainScroll.offsetWidth / mainScroll.scrollWidth / ratio;

      const oHeight = (180 * mainScroll.offsetHeight) / mainScroll.scrollHeight - 60 * (17 / 297);
      const oWidth = (240 * mainScroll.offsetWidth) / mainScroll.scrollWidth;

      const nHeight = 180 * screenHeight - 60 * (17 / 297);
      const nWidth = 240 * screenWidth;

      const aLeft = (oWidth - nWidth) / 2;
      const aTop = (oHeight - nHeight) / 2;

      const nLeft = aLeft + 240 * (mainScroll.scrollLeft / mainScroll.scrollWidth);

      const nTop = (180 * mainScroll.scrollTop) / mainScroll.scrollHeight + 60 * (17 / 297) + aTop;

      this.setState({
        mViewStyle: {
          height: nHeight,
          width: nWidth,
          top: nTop,
          left: nLeft
        }
      });
    }
  }

  componentWillUnmount() {
    const mainScroll = document.getElementById("mainScroll");

    mainScroll.removeEventListener("scroll", this.handleMainScroll);

    if (this.updateAnimation !== undefined) {
      clearInterval(this.updateAnimation);
    }
  }

  handleMainScroll(e) {
    const mainScroll = document.getElementById("mainScroll");

    if (mainScroll) {
      const screenHeight = mainScroll.offsetHeight / mainScroll.scrollHeight;
      const screenWidth = mainScroll.offsetWidth / mainScroll.scrollWidth;

      this.setState({
        mViewStyle: {
          height: 180 * screenHeight - 60 * (17 / 297),
          width: 240 * screenWidth,
          top: (180 * mainScroll.scrollTop) / mainScroll.scrollHeight + 60 * (17 / 297),
          left: (240 * mainScroll.scrollLeft) / mainScroll.scrollWidth
        }
      });
    }
  }

  render() {
    const { mViewStyle } = this.state;

    return <div className={styles.miniView} style={{ ...mViewStyle }} />;
  }
}
